var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4173 23.6588C18.937 23.6588 24.2223 18.3735 24.2223 11.8538C24.2223 5.33411 18.937 0.0488281 12.4173 0.0488281C5.89758 0.0488281 0.612305 5.33411 0.612305 11.8538C0.612305 18.3735 5.89758 23.6588 12.4173 23.6588Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42655 15.2159C9.11709 15.3055 8.78998 15.3535 8.45166 15.3535C6.51866 15.3535 4.95166 13.7865 4.95166 11.8535C4.95166 9.92052 6.51866 8.35352 8.45166 8.35352C8.78998 8.35352 9.11709 8.40152 9.42655 8.49109C8.50055 9.31531 7.91728 10.5163 7.91728 11.8535C7.91728 13.1907 8.50055 14.3917 9.42655 15.2159ZM8.45166 7.35352C9.16326 7.35352 9.83628 7.51869 10.4345 7.81278C11.0327 7.51869 11.7057 7.35352 12.4173 7.35352C13.1289 7.35352 13.8019 7.51869 14.4001 7.81278C14.9983 7.51869 15.6713 7.35352 16.3829 7.35352C18.8682 7.35352 20.8829 9.36823 20.8829 11.8535C20.8829 14.3388 18.8682 16.3535 16.3829 16.3535C15.6713 16.3535 14.9983 16.1883 14.4001 15.8943C13.8019 16.1883 13.1289 16.3535 12.4173 16.3535C11.7057 16.3535 11.0327 16.1883 10.4345 15.8943C9.83628 16.1883 9.16326 16.3535 8.45166 16.3535C5.96638 16.3535 3.95166 14.3388 3.95166 11.8535C3.95166 9.36823 5.96638 7.35352 8.45166 7.35352ZM13.4817 15.2936C13.1453 15.3975 12.7878 15.4535 12.4173 15.4535C10.4291 15.4535 8.81729 13.8417 8.81729 11.8535C8.81729 9.86529 10.4291 8.25352 12.4173 8.25352C12.7878 8.25352 13.1453 8.3095 13.4817 8.41347C12.5039 9.23893 11.8829 10.4737 11.8829 11.8535C11.8829 13.2333 12.5039 14.4681 13.4817 15.2936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.e4956309e7ec669cae3f58765ddf6ef2.svg";
export { ForwardRef as ReactComponent };